export const FETCH_ALL = 'defaultDashboards/FETCH_ALL';
export const FETCH_ALL_SUCCESS = 'defaultDashboards/FETCH_ALL_SUCCESS';
export const FETCH_ALL_ERROR = 'defaultDashboards/FETCH_ALL_ERROR';

export const CREATE = 'defaultDashboards/CREATE';
export const CREATE_SUCCESS = 'defaultDashboards/CREATE_SUCCESS';
export const CREATE_ERROR = 'defaultDashboards/CREATE_ERROR';

export const UPDATE = 'defaultDashboards/UPDATE';
export const UPDATE_SUCCESS = 'defaultDashboards/UPDATE_SUCCESS';
export const UPDATE_ERROR = 'defaultDashboards/UPDATE_ERROR';

export const DELETE = 'defaultDashboards/DELETE';
export const DELETE_SUCCESS = 'defaultDashboards/DELETE_SUCCESS';
export const DELETE_ERROR = 'defaultDashboards/DELETE_ERROR';

export const SET_ACTIVE_DASHBOARD_ID = 'defaultDashboards/SET_ACTIVE_DASHBOARD_ID';

export const SET_CURRENT_BREAKPOINT = 'defaultDashboards/SET_CURRENT_BREAKPOINT';
